import { Controller } from '@hotwired/stimulus'

import MorphReconnect from '../mixins/morph_reconnect'

// Inline scripts don't survive Turbo morphs; this controller re-runs `connect`
// on `turbo:morph` so the modal also opens on morphed-in renders.
export default class extends MorphReconnect(Controller) {
  static values = { open: { type: Boolean, default: false } }

  connect () {
    super.connect()

    if (!this.openValue) return

    this.element.showModal()

    // Turbo morph removing an open dialog fires `close` too; only reload on user-initiated closes.
    this.closedByUser = false
    this.bindMarkClosedByUser = () => { this.closedByUser = true }
    this.bindReloadOnClose = () => {
      if (!this.closedByUser) return
      this.closedByUser = false
      // eslint-disable-next-line no-undef
      Turbo.visit(window.location.href, { action: 'replace' })
    }
    this.element.querySelectorAll('form[method="dialog"]').forEach((form) =>
      form.addEventListener('submit', this.bindMarkClosedByUser))
    this.element.addEventListener('close', this.bindReloadOnClose)
  }

  disconnect () {
    if (this.bindReloadOnClose) {
      this.element.removeEventListener('close', this.bindReloadOnClose)
      this.element.querySelectorAll('form[method="dialog"]').forEach((form) =>
        form.removeEventListener('submit', this.bindMarkClosedByUser))
    }

    super.disconnect()
  }
}
